<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="computedIsFetched">
      <card-title-row translation-path="sidebar.failures" :amount="1" :is-plural="true">
        <template #buttons>
          <base-rounded-button
            v-if="permissionsFailures.main_value > 1"
            icon="mdi-plus"
            size="x-small"
            color="success"
            :tooltip="$i18n.t('button.createFailure')"
            @click="toggleFailureAdding"
          />
        </template>
      </card-title-row>
      <card-title-row
        is-subtitle
        translation-path="sidebar.visualisationOnMap"
        :amount="1"
        :is-plural="true"
        class="pt-2"
      />
      <sidebar-row class="pt-2">
        <sidebar-select-row
          translation-path="sidebar.visualizationType"
          font-size="14px"
          @input="handleStyleChange"
          :value="currentStyle"
          :select-props="styleSelectProps"
        />
      </sidebar-row>
      <module-legend border-bottom module-name="failures" ref="moduleLegend" />

      <v-row no-gutters class="pr-2 pt-2">
        <main-loader v-if="isListLoading" />
        <v-col cols="12" v-else>
          <card-title-row
            is-subtitle
            translation-path="sidebar.activeFailuresList"
            :amount="1"
            :is-plural="true"
            class="py-2"
          />
          <sidebar-row flex-wrap="flex-nowrap" slot-cols="11">
            <failures-list :failures="failures" />
          </sidebar-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else>
      <main-loader />
    </v-col>
  </v-row>
</template>
<script>
import { get, call } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import FailuresList from '@/components/FailuresList';
import MainLoader from '@/components/MainLoader';
import SidebarSelectRow from '@/components/SidebarSelectRow';
import SidebarRow from '@/components/SidebarRow';
import ModuleLegend from '@/components/ModuleLegend';

export default {
  name: 'Failures',
  components: {
    ModuleLegend,
    SidebarRow,
    CardTitleRow,
    FailuresList,
    MainLoader,
    SidebarSelectRow,
  },
  data: () => ({
    isFailureAdding: false,
    isListLoading: true,
    isFetched: false,
  }),
  computed: {
    dataSourceName: get('admin/modulesMapping@failures.datasource_name'),
    currentStyle: get('styles/currentStyle@:dataSourceName'),
    defaultStyle: get('styles/defaultStyle@:dataSourceName'),
    failures: get('failures/failures'),
    permissions: get('users/toolsPermissions'),
    styles: get('styles/styles@:dataSourceName'),
    loaded: get('modules/loaded@:dataSourceName'),
    permissionsFailures() {
      return this.permissions['FAILURES'];
    },
    computedIsFetched() {
      return this.isFetched && this.loaded;
    },
    computedSelectStyles() {
      return [this.defaultStyle, ...this.$_sortObjectsByAttribute([...this.styles], 'name')];
    },
    styleSelectProps() {
      return {
        items: this.computedSelectStyles,
        itemText: 'name',
        itemValue: 'id',
        returnObject: true,
      };
    },
  },
  methods: {
    getFailures: call('failures/getFailures'),
    getStyles: call('styles/getStyles'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    toggleFailureAdding() {
      this.$router.push({
        name: 'failure',
        params: { fid: 'new' },
      });
    },
    async handleStyleChange(style) {
      await this.setCurrentStyle({ dataSource: this.dataSourceName, style: style });
      this.$root.$emit('failuresStyleChanged', style);
      await this.$refs.moduleLegend.getModuleStyle();
    },
    async init() {
      await Promise.all([this.getFailures(), this.getStyles(this.dataSourceName)]);
      this.isListLoading = false;
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped></style>
